import { ShoppingBag, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

export function PurchaseLinks({ links, accentHex }) {
  const affiliate = links.some((l) => l.affiliate);
  return (
    <section data-testid="purchase-links"
      className="mt-8 p-6 rounded-2xl bg-panel border-2 border-line border-l-[6px]"
      style={{ borderLeftColor: accentHex }}>
      <div className="flex items-center gap-2 mb-1">
        <ShoppingBag size={17} style={{ color: accentHex }} />
        <h2 className="font-editorial font-bold text-xl text-stone-900">Puoi acquistare su:</h2>
      </div>
      <p className="text-sm text-stone-500 mb-4">
        Tre marketplace seri dove cercare l'oggetto di cui parla l'articolo. Confronta sempre più annunci prima di comprare.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {links.map((l, i) => (
          <a key={l.name} href={l.url} target="_blank" rel="sponsored nofollow noopener noreferrer"
            data-testid={`purchase-link-${i}`}
            className="lift group flex items-center justify-between gap-2 rounded-xl border-2 border-line bg-ink px-4 py-3 font-semibold text-stone-800 hover:border-stone-900 transition-colors">
            <span className="flex flex-col">
              <span>{l.name}</span>
              <span className="text-[10px] font-meta uppercase tracking-wider text-stone-400">
                {l.kind === "specialist" ? "Sito specializzato" : "Marketplace"}
              </span>
            </span>
            <ExternalLink size={15} className="text-stone-400 group-hover:text-stone-900 transition-colors" />
          </a>
        ))}
      </div>
      <p className="mt-4 text-[11px] text-stone-500" data-testid="purchase-disclosure">
        Link verso siti esterni non gestiti da Collezionatico: prezzi, disponibilità e affidabilità dei venditori vanno verificati sul sito di destinazione.
        {affiliate
          ? " Alcuni sono link di affiliazione: se acquisti, potremmo ricevere una piccola commissione senza costi aggiuntivi per te."
          : " In futuro alcuni di questi link potrebbero diventare link di affiliazione, senza costi aggiuntivi per te."}
        {" "}<Link to="/note-legali" className="underline hover:text-stone-800">Maggiori informazioni</Link>.
      </p>
    </section>
  );
}
